import router from './router';

export default router;



// WEBPACK FOOTER //
// ./src/app/errors/index.js